import React, { useState } from "react";
import { kmsConnect, WrappedProps as KmsConnectProps } from "@kaltura/mediaspace-shared-kms-connect";
import { baseUrl } from "@kaltura/mediaspace-shared-utils";
import VerificationForm from "./VerificationForm";
import { QueryParams } from "@kaltura/mediaspace-shared-types";

export interface VerificationFormContainerProps extends KmsConnectProps {
    recaptchaSiteKey?: string;
    recaptchaTheme?: "dark" | "light" | undefined;
    recapthcaMode?: "normal" | "invisible" | undefined;
    onSubmit: () => void;
    submitUrl?: string;
}

function VerificationFormContainer({
    recaptchaSiteKey,
    recaptchaTheme,
    recapthcaMode,
    onSubmit,
    getFromKms,
    submitUrl = "/registration/send-verification-email",
}: VerificationFormContainerProps) {
    const [processing, setProcessing] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState();

    // submit the form to kms
    const handleSubmit = (data: Record<string, unknown>) => {
        setProcessing(true);
        getFromKms
            && getFromKms(
                data as QueryParams,
                (registerResult) => {
                    setProcessing(false);

                    if (registerResult.result) {
                        onSubmit();
                    }

                    if (registerResult.errorMessage) {
                        setErrorMessage(registerResult.errorMessage);
                    }
                },
                `${baseUrl}${submitUrl}`,
                false
            );
    };

    return (
        <VerificationForm
            recaptchaSiteKey={recaptchaSiteKey}
            recaptchaTheme={recaptchaTheme}
            recapthcaMode={recapthcaMode}
            onSubmit={handleSubmit}
            processing={processing}
            errorMessage={errorMessage}
        />
    );
}

export default kmsConnect<VerificationFormContainerProps>(VerificationFormContainer);
